var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassPrefix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Huge-icon_ecommerce_outline_shield",
    "data-name": "Huge-icon/ecommerce/outline/shield",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.355,
    height: 20.432,
    viewBox: "0 0 19.355 20.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    d: "M3.064,3.316l-.3-.685Zm5-2.221.3.685h0Zm3.249,0,.3-.685h0Zm4.978,2.212-.3.685h0ZM.756,6.977.007,7.02ZM7.622,19.05l.42-.621h0Zm4.129,0,.421.621h0ZM18.6,7l-.749-.048h0ZM3.368,4l5-2.221L7.757.409l-5,2.221ZM11.006,1.78l4.978,2.212.609-1.371L11.615.409Zm-11,5.24a16.2,16.2,0,0,0,1.908,7.495A16.382,16.382,0,0,0,7.2,19.671l.841-1.242a14.929,14.929,0,0,1-4.833-4.672A14.746,14.746,0,0,1,1.5,6.933ZM12.172,19.671a16.256,16.256,0,0,0,5.272-5.183,16.474,16.474,0,0,0,1.9-7.442l-1.5-.1a15.014,15.014,0,0,1-1.7,6.785A14.8,14.8,0,0,1,11.33,18.43Zm-4.97,0a4.436,4.436,0,0,0,4.97,0L11.33,18.43a2.935,2.935,0,0,1-3.287,0ZM8.366,1.78a3.25,3.25,0,0,1,2.64,0L11.615.409a4.75,4.75,0,0,0-3.858,0Zm7.618,2.212A3.062,3.062,0,0,1,17.849,6.95l1.5.1a4.562,4.562,0,0,0-2.753-4.424ZM2.759,2.631A4.554,4.554,0,0,0,.007,7.02l1.5-.087A3.055,3.055,0,0,1,3.368,4Z",
    transform: "translate(0 0)",
    fill: "#656971"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1592",
    "data-name": "Vector 1592",
    d: "M1.219,2.164A.75.75,0,0,0,.282,3.336ZM2.5,4.152l.469-.586h0ZM3.88,4.03l-.564-.494h0ZM7.314,1.244A.75.75,0,1,0,6.186.256ZM.282,3.336l1.753,1.4.937-1.171-1.753-1.4ZM4.445,4.524l2.87-3.28L6.186.256l-2.87,3.28Zm-2.41.214a1.75,1.75,0,0,0,2.41-.214L3.316,3.536a.25.25,0,0,1-.344.031Z",
    transform: "translate(5.936 6.623)",
    fill: "#656971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassPrefix);
export default __webpack_public_path__ + "static/media/pass-prefix.94eba09d15f7a083ec936078353c02e1.svg";
export { ForwardRef as ReactComponent };